// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"405":"a9d2f48d","655":"4030ae0c","705":"56ded769","709":"aca8398d","787":"cb7f03c4","881":"c813355b"}[chunkId] + ".chunk.js";
};